export const greenEnergyEfficient = [
    'Appliances',
    'Construction',
    'Doors',
    'Exposure/Shade',
    'Healthy Living Features',
    'HVAC',
    'Incentives',
    'Insulation',
    'Lighting',
    'Materials and Construction',
    'Roof',
    'Solar Panel',
    'Sustainability',
    'Thermostat',
    'Water Conservation',
    'Water Heater',
    'Wind Turbines',
    'Windows',
    'None',
    'See Remarks'
];

export const GreenSustainability = [
    'Conserving Methods',
    'Onsite Recycling Center',
    'Recyclable Materials',
    'Recycled Materials',
    'Regionally-Sourced Materials',
    'Renewable Materials',
    'Salvaged Materials',
    'None',
    'See Remarks'
];

export const greenBuildingVerificationTypeOptions = [
    'Building America',
    'Certified Passive House',
    'ENERGY STAR Certified Homes',
    'EnerPHit',
    'Environments for Living',
    'HERS Index Score',
    'Home Energy Score',
    'Home Energy Upgrade Certificate of Energy Efficiency Improvements',
    'Home Energy Upgrade Certificate of Energy Efficiency Performance',
    'Home Performance with ENERGY STAR',
    'Indoor airPLUS',
    'LEED For Homes',
    'Living Building Challenge',
    'NGBS New Construction',
    'NGBS Small Projects Remodel',
    'NGBS Whole-Home Remodel',
    'PHIUS+',
    'WaterSense Certified Home',
    'Zero Energy Ready Home',
    'See Remarks'
];
